<template>
  <v-container class="px-0" fluid>
    <v-layout wrap>
      <h2 class="black--text text-h5 font-weight-bold">Block</h2>
      <v-spacer></v-spacer>
      <BlockCreateForm
        v-if="hasRole(AdminUserPermissions.LOCATION_ADD)"
        :block="block"
      />
      <AuditTrialLog class="ms-2 ms-md-4" auditType="BLOCK_LOG" />
    </v-layout>
    <app-block-table
      :blockList="blockList"
      :totalItemsCount="totalItemsCount"
    ></app-block-table>
  </v-container>
</template>

<script>
import BlockTable from "../components/BlockTable.vue";
import BlockCreateForm from "../components/BlockCreateForm.vue";
import AuditTrialLog from "@/audit-trial-log/components/AuditTrialLog.vue";

export default {
  components: {
    BlockCreateForm,
    "app-block-table": BlockTable,
    AuditTrialLog
  },
  data() {
    return {
      textFields: [],
      tags: [],
      loading: true,
      areaList: [],
      blockList: [],
      totalItemsCount: 0,
      area: {
        NameEn: "",
        NameAr: ""
      },
      shift: {
        NameEn: "",
        NameAr: ""
      },
      block: "",
      zone: "",
      search: ""
    };
  },
  created() {},
  apollo: {
    getAllAreas() {
      return {
        query: require("../api/getAllAreas.graphql"),
        result({ data, loading }) {
          this.loading = loading;
          this.areaList = data.getAllAreas.areas;
          this.totalItemsCount = data.getAllAreas.totalCount;
        }
      };
    }
  },
  methods: {
    runSearch() {
      this.$apollo.queries.getAllAreas.refetch({
        searchKey: this.search
      });
    },
    clearSearch() {
      this.search = "";
      this.$apollo.queries.getAllAreas.refetch({
        searchKey: ""
      });
    }
  }
};
</script>
